module.exports = __webpack_public_path__ + "img/coins-fullGrey.f01f6079.svg";